import { render, staticRenderFns } from "./ConsignmentNotesList.vue?vue&type=template&id=7644f781&scoped=true&"
import script from "./ConsignmentNotesList.vue?vue&type=script&lang=js&"
export * from "./ConsignmentNotesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7644f781",
  null
  
)

export default component.exports